import React from 'react';

const TermsConditions = ({ terms_conditions }) => {
  if (!Array.isArray(terms_conditions)) {
    return <div>Invalid data for terms and conditions.</div>; 
  }

  return (
    <div>
      <div className="wg-property single-property-nearby">
        <div className="wg-title text-11 fw-6 text-color-heading">Terms & Conditions</div>
        <div className="flex-column box-nearby gap-4"> 
          <ul className="box-benefits d-flex flex-column gap-4"> 
            {terms_conditions.map((term, index) => (
              <li key={index} className="item-benefit d-flex flex-column flex-md-row gap-4"> 
                <div className="d-flex flex-column gap-3">
                  <p className="fw-7 label text-4 whitespace-nowrap">
                    {term.title} 
                  </p>
                  {Array.isArray(term.value) ? ( 
                    <ul className='ps-4'>
                      {term.value.map((value, valueIndex) => (
                        <li key={valueIndex}>
                          <span className="bullet-point">
                            &#8226; {value}
                          </span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>No values available for this term.</p> 
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
